import React from 'react';
import {FormattedMessage} from 'react-intl';

import {SettingsForm} from './SettingsForm';

import {IStore} from 'redux/interface';
import {useSelector} from 'react-redux';
import {SET_USER_DATA} from 'redux/auth/actions';
import {getTranslations} from 'redux/pageAsyncActions';

import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {TranslationKeys} from 'utils/constants/routeConstants';

import Loader from 'components/loader';
import SettingImg from 'assets/image/user-settings/settings-img.png';

import './styles.scss';

export const UserSettings = (): JSX.Element => {
  const {
    userProfile
  } = useSelector((state: IStore) => state.auth);
  const {
    loading
  } = useSelector((state: IStore) => state.status);

  useGetTranslations({
    translationKey: TranslationKeys.Settings
  });

  return (
    <section className="settings">

      {
        !loading.includes(getTranslations) && <>
          <div className="settings__label">
            {/* <img className="settings__image" src={SettingImg} alt="Settings"/>*/}
            <p className="settings__title">
              <FormattedMessage
                id="gritx.user-settings.account"
                defaultMessage="Account"
              />
            </p>
          </div>
          <div className="settings__line"></div>
          {
            loading.includes(SET_USER_DATA) || !userProfile
              ? <Loader className="settings__loader"/>
              : <SettingsForm/>
          }
        </>
      }
    </section>
  );
};
